/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

export const UPDATE_FIELD_PROMOTION_FORM = 'mbp-checkout/UPDATE_FIELD_PROMOTION_FORM';
export const CLEAR_ALL_FIELD_PROMOTION_FORM = 'mbp-checkout/CLEAR_ALL_FIELD_PROMOTION_FORM';
